import { render } from "./CategoryFilter.vue?vue&type=template&id=2052afca&scoped=true&ts=true"
import script from "./CategoryFilter.vue?vue&type=script&lang=ts"
export * from "./CategoryFilter.vue?vue&type=script&lang=ts"

import "./CategoryFilter.vue?vue&type=style&index=0&id=2052afca&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Roshaw\\WebstormProjects\\random-song\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2052afca"]])

export default __exports__